import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fileInput", "loading"];

  dragover(event) {
    event.preventDefault();
  }

  drop(event) {
    event.preventDefault();

    this.fileInputTarget.files = event.dataTransfer.files;
    this.fileInputTarget.dispatchEvent(new Event("change"));
  }

  toggleLoading() {
    [...this.loadingTarget.children].forEach((element) => {
      element.classList.toggle("hidden");
    });
  }
}
